<template>
  <div id="map-featured" class="map-featured">
    <div v-html="content"></div>
    <span @click="$emit('close')" class="close"><i class="icon icon-cross"></i></span>
  </div>

</template>

<script>


export default {
    props: {
        content: {
            default: '',
            type:String
        },

    },
    mounted: function () {

    }

}
</script>

